// extracted by mini-css-extract-plugin
module.exports = {"container":"_3JGFAVszopLJpcR41dTc9d","groupsList":"_2L7p4p3WfIb5Q8E4psLKND"};